// Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

export const SnackMessage = {
  error: {
    fetchPrivileges: "Failed to fetch Privileges",
    insufficientPrivileges: "Insufficient Privileges",
  },
};

export const APP_DESC =
  "Net-Insights is a comprehensive analytics solution designed to provide deep insights of network users";

export const redirectUrl = "web-app-marketplace-redirect-url";
